import * as React from 'react';
import { StyledHeaderSectionContainer, StyledFirstTextTitle, StyledSecondTextTitle, StyledGridTextContainer } from './IntelligentPageGuidanceInfo.style';
export const IntelligentPhotoCaptureScreenTitle = ({ firstText, secondText }) => {
    return (React.createElement(StyledHeaderSectionContainer, null,
        React.createElement(StyledGridTextContainer, { container: true, justify: "center", alignItems: "center", direction: "column" },
            React.createElement(StyledFirstTextTitle, null, firstText),
            React.createElement(StyledSecondTextTitle, null, secondText))));
};
//# sourceMappingURL=IntelligentPhotoCaptureScreenTitle.js.map